// Local translations
export const T = {
  en_GB: {
    failedToLoad: "Failed to load mandate settings.",
    // QL-375 (open question 1) — the goal-type mandate mode is the only thing
    // that makes a goal use a mandate, and it lives on the goal-type rows.
    noGoalTypesWarning:
      "This collection has no goal types, so no goal can use a mandate. Add a goal type on the Goal Types tab and enable its mandate.",
  },
  nb_NO: {
    failedToLoad: "Kunne ikke laste mandatinnstillinger.",
    noGoalTypesWarning:
      "Denne samlingen har ingen måltyper, så ingen mål kan bruke et mandat. Legg til en måltype under Måltyper og aktiver mandatet.",
  },
} as const;
